import { CarrierLogo } from './components/CarrierLogo';
import { MerchantLogo } from './components/MerchantLogo';
import { SMELogo } from './components/SMELogo/SMELogo';

export type LogoSize = 'small' | 'large';
type ShipmentLogoVariant = 'merchant' | 'carrier' | 'sme';

interface BaseLogoProps {
  variant: ShipmentLogoVariant;
}

export interface IMerchantLogoProps extends BaseLogoProps {
  variant: 'merchant';
  merchantLogo?: string;
  merchantName?: string;
  /** Defaults to small */
  size?: LogoSize;
}

export interface ICarrierLogoProps extends BaseLogoProps {
  variant: 'carrier';
  carrierName?: string;
  carrierLogo?: string;
}

export interface ISMELogoProps extends BaseLogoProps {
  variant: 'sme';
  smeLogo?: string;
  merchantName?: string;
  size?: LogoSize;
}

type LogoProps = IMerchantLogoProps | ICarrierLogoProps | ISMELogoProps;

const ShipmentLogo: React.FC<LogoProps> = (props) => {
  const { variant } = props;

  if (variant === 'merchant') {
    return <MerchantLogo merchantLogo={props.merchantLogo} merchantName={props.merchantName} size={props.size} />;
  }
  if (variant === 'carrier') {
    return <CarrierLogo carrierLogo={props.carrierLogo} carrierName={props.carrierName} />;
  }

  return <SMELogo smeLogo={props.smeLogo} merchantName={props.merchantName} size={props.size} />;
};

export { ShipmentLogo };
